import { render } from "./WebRadios.vue?vue&type=template&id=5f037e19"
import script from "./WebRadios.vue?vue&type=script&lang=js"
export * from "./WebRadios.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__